import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import ProjectService from "../services/ProjectService";
import Breadcrumb from "../components/Breadcrumb";
import StorageService from "../services/StorageService";
import ReactPaginate from "react-paginate";
import Loading from "../components/loading";
import ProjectWorkItemsService from "../services/ProjectWorkItemsService";
import utility from "../utils/utility";
// import EmployeePermissionService from "../services/EmployeePermissionService";
import ScreenData from "../config/ScreenData";
import usePermission from "../utils/UsePermission";
import UnAuthorized from "../views/Unathorized";
import MessageDialog from "../components/MessageDialog";


export default function ViewProjects() {
  const [projects, setProjects] = useState([]);
  const [selected, setSelected] = useState(null); // RADIO (single select)
  const [searchText, setSearchText] = useState(""); // SEARCH
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("");
  const [loading, setLoading] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [viewData, setViewData] = useState(null);
  // const messageTimer = useRef(null);
  const navigate = useNavigate();

  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  useEffect(() => {
    fetchProjects();
  }, [currentPage, searchText]);

  const fetchProjects = async () => {
    setLoading(true);
    try {

      const login = StorageService.loginData();

      const companyId = StorageService.activeCompany().companyId;
      const response = await ProjectService.getAllProjects(
        companyId,
        currentPage,
        itemsPerPage,
        searchText
      );
      setProjects(response.data || []);
      setPageCount(response.totalPages);
    } catch (err) {
      console.error(err);
      showMessage("Error fetching projects.", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [searchText]);

  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
    // clearTimeout(messageTimer.current);
    // messageTimer.current = setTimeout(() => setMessage(""), 4000);
  };
  const { permission, can } = usePermission(
    ScreenData.Project,
    showMessage
  );



  useEffect(() => {
    if (permission === null) return;

    if (permission.canView !== 1) {
      setLoading(false);
      return;
    }

    fetchProjects();
  }, [permission]);




  // const closeMessage = () => {
  //   setMessage("");
  //   clearTimeout(messageTimer.current);
  // };


  const handleSelect = (id) => {
    setSelected(id);
  };


  const handleAdd = () => {

    navigate("/cpnl/projects/add");
  };


  const handleModify = () => {
    if (!selected) {
      showMessage("Please select one Project to modify.");
      return;
    }

    const project = projects.find((p) => p.id === selected);

    if (project?.status === "Inactive") {
      showMessage("Inactive records cannot be modified", "error");
      return;
    }


    navigate(`/cpnl/projects/add/${selected}`);
  };


  const handleView = async () => {
    if (!selected) {
      showMessage("Select one project to view.", "error");
      return;
    }

    try {
      setLoading(true);
      const res = await ProjectService.getById(selected);
      const project = res.data || res;

      console.log("VIEW DATA =", project);
      console.log("PROJECT WORK ITEMS =", project.projectWorkItems);

      // const workItemsRes = await ProjectWorkItemsService.getByProjectId(selected);

      // project.projectWorkItems = workItemsRes?.data || [];

      setViewData(project);
      setShowViewModal(true);
    } catch (err) {
      console.error(err);
      showMessage("Failed to load project details", "error");
    } finally {
      setLoading(false);
    }
  };


  const handleToggleStatus = async (proj) => {
    if (!can("canModify")) {
      showMessage("You don't have permission to modify status", "error");
      return;
    }
    const newStatus = proj.status === "Active" ? "Inactive" : "Active";

    if (!window.confirm(`Update status to ${newStatus}?`)) return;

    try {
      await ProjectService.updateStatus(proj.id, newStatus);
      fetchProjects();
      showMessage("Status updated successfully", "success");
    } catch (error) {
      console.error(error);
      showMessage("Error updating status", "error");
    }
  };

  // const formatDate = (dateStr) => {
  //   if (!dateStr) return "-";
  //   const date = new Date(dateStr);
  //   return `${String(date.getDate()).padStart(2, "0")}-${String(
  //     date.getMonth() + 1
  //   ).padStart(2, "0")}-${date.getFullYear()}`;
  // };

  const handlePageClick = (event) => {
    const _cp = event.selected + 1;
    setCurrentPage(_cp);
    fetchProjects();
  };


  // const filteredProjects = projects.filter(
  //   (proj) =>
  //     proj.projectName?.toLowerCase().includes(searchText.toLowerCase()) ||
  //     proj.projectCode?.toLowerCase().includes(searchText.toLowerCase())
  // );
  const filteredProjects = projects;

  if (permission === null) {
    return <div className="text-center mt-5">Loading...</div>;
  }

  if (!permission || permission.canView !== 1) {
    return <UnAuthorized />;
  }

  return (
    <>
      <Breadcrumb pageTitle="Projects" secondTitle="Masters" />

      <div className="row">
        <div className="card py-2 bg-white shadow-sm">
          {/* {message && (
            <div
              className={`alert ${msgType === "success" ? "alert-success" : "alert-danger"
                } d-flex justify-content-between align-items-center w-100 mb-2 p-2`}
            >
              <span>{message}</span>
              <button type="button" className="btn-close" onClick={closeMessage}></button>
            </div>
          )} */}


          <MessageDialog
            message={message}
            type={msgType}
            setMessage={setMessage}
            setMsgType={setMsgType}
          />


          {/*  SEARCH + BUTTONS */}
          <div className="mb-3 pb-2 border-bottom d-flex align-items-end gap-3">
            <div>
              <input
                type="text"
                className="form-control"
                placeholder="Search Project"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
            <div className="ms-auto d-flex gap-2">
              {can("canAdd") && (
                <button className="btn btn-success" onClick={handleAdd}>
                  <i className="ti ti-plus me-1"></i> Add
                </button>
              )}

              {can("canModify") && (
                <button
                  className="btn btn-warning"
                  onClick={handleModify}
                  disabled={!selected}
                >
                  <i className="ti ti-pencil me-1"></i> Modify
                </button>
              )}

              {can("canView") && (
                <button
                  className="btn btn-primary"
                  onClick={handleView}
                  disabled={!selected}
                >
                  <i className="ti ti-eye me-1"></i> View
                </button>
              )}
            </div>
          </div>

          {/* TABLE */}
          <div className="table-responsive">
            <table className="table table-striped table-bordered mb-0">
              <thead className="table-light">
                <tr>
                  <th>Select</th>
                  <th>Project Name</th>
                  <th>Category</th>
                  <th>Project Code</th>
                  {/* <th>Item Category</th> */}
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Contractor</th>
                  <th>Start CHINAGE</th>
                  <th>End CHINAGE</th>
                  <th>Total CHINAGE</th>
                  <th>Status</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="11" className="text-center py-4">
                      <Loading />
                    </td>
                  </tr>
                ) : filteredProjects.length > 0 ? (
                  filteredProjects.map((proj) => {
                    const isActive = proj.status === "Active";
                    return (
                      <tr key={proj.id}>
                        <td>
                          <input
                            type="radio"
                            name="projectSelect"
                            disabled={!isActive}
                            checked={selected === proj.id}
                            onChange={() => handleSelect(proj.id)}
                          />
                        </td>
                        <td>{proj.projectName}</td>
                        <td>{proj.projectCategoryName}</td>
                        <td>{proj.projectCode}</td>
                        {/* <td>{proj.itemCategoryName}</td> */}
                        <td>{utility.formatDateDDMMMYYYY(proj.projectStartDate)}</td>
                        <td>{utility.formatDateDDMMMYYYY(proj.projectEndDate)}</td>
                        <td>{proj.contractorName}</td>
                        <td>{proj.fromKMS}</td>
                        <td>{proj.toKMS}</td>
                        <td>{proj.totalChainage}</td>
                        <td>
                          <span
                            className={`badge ${isActive ? "bg-success" : "bg-secondary"
                              }`}
                            style={{ cursor: can("canModify") ? "pointer" : "default" }}
                            onClick={() => handleToggleStatus(proj)}
                          >
                            {isActive ? "Active" : "Inactive"}
                          </span>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="12" className="text-center text-muted">
                      No projects found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            <ReactPaginate
              breakLabel="..."
              nextLabel="Next >"
              onPageChange={handlePageClick}
              pageRangeDisplayed={3}
              marginPagesDisplayed={2}
              pageCount={pageCount}
              previousLabel="< Previous"
              containerClassName="pagination-container"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              activeClassName="active"
            />
          </div>
        </div>
      </div>

      {/* VIEW MODAL */}
      {showViewModal && viewData && (
        <ProjectViewModal
          viewData={viewData}
          close={() => setShowViewModal(false)}
        />
      )}
    </>
  );
}

/* ------------------ VIEW MODAL ------------------ */
function ProjectViewModal({ viewData, close }) {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.5)",
        zIndex: 999,
      }}
    >
      <div
        style={{
          position: "fixed",
          bottom: "-40%",
          top: "55%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "750px",
          background: "#fff",
          borderRadius: "10px",
          maxHeight: "90vh",
          overflowY: "auto",
          paddingBottom: "10px",
        }}
      >
        <div
          className="d-flex justify-content-between align-items-center"
          style={{ padding: "16px 20px", borderBottom: "1px solid #ddd" }}
        >
          <h5 className="mb-0">Project Details</h5>
          <button className="btn btn-sm btn-outline-secondary" onClick={close}>
            <i className="ti ti-x"></i>
          </button>
        </div>

        <div style={{ padding: "20px" }}>
          <div className="row">
            <div className="col-md-6">
              <Field label="Project Name" value={viewData.projectName} />
              <Field label="Project Category" value={viewData.projectCategoryName} />
              <Field
                label="Project Start Date"
                value={utility.formatDateDDMMMYYYY(viewData.projectStartDate)}
              />
              <Field label="From KM" value={viewData.fromKMS} />
              <Field label="Total Chainage" value={viewData.totalChainage} />
              <Field label="Company" value={viewData.companyName} />
              <Field
                label="Created By"
                value={
                  viewData.createdByName
                    ? `${viewData.createdByName}${viewData.createdByCode ? ` - ${viewData.createdByCode}` : ""}`
                    : "-"
                }
              />
            </div>

            <div className="col-md-6">
              <Field label="Project Code" value={viewData.projectCode} />
              <Field label="Contractor" value={viewData.contractorName} />
              <Field
                label="Project End Date"
                value={utility.formatDateDDMMMYYYY(viewData.projectEndDate)}
              />
              <Field label="To KM" value={viewData.toKMS} />
              <Field label="Description" value={viewData.projectDescription} />
              <Field label="Status" value={viewData.status || viewData.projectStatus} />
              <Field
                label="Updated By"
                value={
                  viewData.updatedByName
                    ? `${viewData.updatedByName}${viewData.updatedByCode ? ` - ${viewData.updatedByCode}` : ""}`
                    : "-"
                }
              />
            </div>

            <hr />

            <h6 className="mb-3">Project Work Items</h6>

            <div className="table-responsive">
              <table className="table table-bordered table-striped table-sm">
                <thead className="table-light">
                  <tr>
                    <th>Sl. No</th>
                    <th>Work Item</th>
                    <th>UOM</th>
                    <th>Quantity</th>
                    <th>Dashboard</th>
                  </tr>
                </thead>
                <tbody>
                  {viewData.projectWorkItems && viewData.projectWorkItems.filter(item => item.isActive === 1).length > 0 ? (
                    [...viewData.projectWorkItems]
                      .filter(item => item.isActive === 1)
                      .sort((a, b) => {
                        const aNum = parseFloat(a.slNo) || 0;
                        const bNum = parseFloat(b.slNo) || 0;
                        if (aNum !== bNum) return aNum - bNum;
                        return String(a.slNo || "").localeCompare(String(b.slNo || ""), undefined, { numeric: true, sensitivity: 'base' });
                      })
                      .map((item, index) => (
                        <tr key={index}>
                          <td>{item.slNo || "-"}</td>
                          <td>{item.workItemCode || "-"}</td>
                          <td>{item.uom || "-"}</td>
                          <td>{Number(item.quantity || 0).toFixed(3)}</td>
                          <td>
                            <span className={`badge ${Number(item.isDashboard) === 1 || item.isDashboard === true || String(item.isDashboard) === '1'
                                ? "bg-success"
                                : "bg-secondary"
                              }`}>
                              {Number(item.isDashboard) === 1 || item.isDashboard === true || String(item.isDashboard) === '1' ? "Yes" : "No"}
                            </span>
                          </td>
                        </tr>
                      ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center text-muted">
                        No Work Items Added
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

          </div>

        </div>

        <div className="d-flex justify-content-end px-3">
          <button className="btn btn-secondary" onClick={close}>
            <i className="ti ti-cancel me-1"></i> Close
          </button>
        </div>
      </div>
    </div>
  );
}

/* ------------------ FIELD ------------------ */
function Field({ label, value }) {
  return (
    <div className="mb-3">
      <label className="form-label">{label}</label>
      <input
        className="form-control"
        readOnly
        value={value || "-"}
        style={{
          backgroundColor: "#f8f9fa",
          color: "#000",
          fontWeight: "600",
          borderColor: "#ced4da",
        }}
      />
    </div>
  );
}
